import { useTranslation } from 'react-i18next';

export function OnOff({ children }: { children?: boolean }) {
  const { t } = useTranslation();
  const valueKey = children == null ? 'null' : children.toString();
  return <>{t(`onOff.${valueKey}`)}</>;
}
